export const environment = {
  production: true,
  apiUrl: 'https://backend.capitoltrades-coll.prod.eu-central-1.master.2iq.cloud',
  oauthProviderUrl: 'https://2iq-prod.auth.eu-central-1.amazoncognito.com/oauth2/authorize',
  clientId: 'upsqmvhc4cg4sfl5givkbtapm',
  userInfo: 'https://2iq-prod.auth.eu-central-1.amazoncognito.com/oauth2/userInfo'
};
